import { AsyncPipe, CurrencyPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { TradeFacade } from '@zero/trade/domain';

@Component({
  selector: 'trade-multi-order-summary',
  imports: [TranslocoPipe, CurrencyPipe, AsyncPipe],
  templateUrl: './multi-order-summary.component.html',
  styleUrl: './multi-order-summary.component.scss',
})
export class MultiOrderSummaryComponent {
  public readonly facade = inject(TradeFacade);
}
